module.exports = __webpack_public_path__ + "media/icons/opony-letnie-green@3x-19517eb9.svg";